import { Box } from "@mui/system";
import { Outlet } from "react-router-dom";
import HomeButton from "../HomeButton";
import VidletBtnLogout from "../VidletBtnLogout";

const LayoutDashboard = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        component="header"
        sx={({ palette, functions, boxShadows }) => ({
          height: functions.pxToRem(53),
          minHeight: functions.pxToRem(53),
          width: "100%",
          backgroundColor: palette.white.main,
          boxShadow: boxShadows.navbarBoxShadow,
          display: "grid",
          justifyItems: "center",
        })}
      >
        <Box
          sx={({ functions, breakpoints }) => ({
            display: "flex",
            px: 2,
            width: "100%",
            alignItems: "center",
            height: "100%",
            "& .dashboard-nav-right": {
              ml: "auto",
            },
          })}
        >
          <HomeButton />
          <div className="dashboard-nav-right">
            <VidletBtnLogout />
          </div>
        </Box>
      </Box>
      <Box
        sx={(theme) => ({
          flex: 1,
          display: "flex",
          overflow: "hidden",
          position: "relative",

          ".scroll-vidlet-content": {
            width: "100%",
            height: "100%",
            overflowX: "hidden",
            overflowY: "auto",
            ...theme.props.cssScrollbarWidth,
          },
        })}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default LayoutDashboard;
